import { styled } from '@stitches/react';
import { useMemo } from 'react';
import { useElements, useScene } from '../../hooks';
import { useKeyboard } from '../../hooks/useEditor';
import { KeyboardData } from '../../types/hooks';

export const IFrameElement = ({ elementID }: { elementID: string }) => {
  const scene = useScene();
  const [keyboard] = useKeyboard<KeyboardData>();
  const [element] = useElements({ id: elementID });

  const IFrame = useMemo(
    () => styled('iframe', element?.props?.class as {}),
    [element?.props?.class]
  );

  return (
    <>
      <IFrame {...scene.launcherStateProps} src={element?.props?.src} />
      <div
        element-type="iframe"
        id={element?.id}
        style={{
          position: 'absolute',
          left: element?.props?.class?.left,
          top: element?.props?.class?.top,
          width: element?.props?.class?.width,
          height: element?.props?.class?.height,
        }}
      />
    </>
  );
};
